import Attack from "./Attacks";
import { GAME_ATTACK_COMMAND_WHITELIST } from "../constants/gameAttackConstants";

class NonResponsiveAttack extends Attack {
    constructor(startTimestamp) {
        super(startTimestamp);
        
        this.init();
    }

    init() {

    }

    update() {

    }

    end(endTimestamp) {
        super.end(endTimestamp);
    }

}
export default NonResponsiveAttack;